import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import {
  TANGELO,
  GRAY1,
  GRAY3,
} from '../../constants/colors';

const QuantityChartStyled = styled.div`
`;

const StyledTableCell = styled(TableCell)`
  border-bottom: 0;
  padding-top: 0;
  padding-bottom: 8px;
  vertical-align: top;
  min-width: 120px;
  text-align: right;
`;

const StyledTableCellBar = styled(TableCell)`
  border-bottom: 0;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 0;
  border-left: 1px solid ${GRAY3};
  vertical-align: top;
  min-width: 50%;
  width: 70%;
`;

const StyledTableCellHead = styled(TableCell)`
  border-bottom: 0;
  padding-top: 0;
  padding-bottom: 8px;
  padding-left: 0;
  vertical-align: top;
  color: ${GRAY1};
  min-width: 120px;
`;

const StyledChartBar = styled.div`
  display: block;
  width: ${(props) => props.size}%;
  background: ${TANGELO};
  height: 16px;
  margin: 2px 0;
`;

const linearScale = (value, maxOld = 100, maxNew = 100, minNew = 0, minOld = 0) => {
  return (((maxNew - minNew) / (maxOld - minOld)) * (value - maxOld)) + maxNew;
};

const QuantityChart = ({
  chartData,
}) => {
  const max = Math.max(...chartData.map((item) => item.value));

  return (
    <QuantityChartStyled>
      <TableContainer>
        <Table aria-label="simple table">
          <TableBody>
            {chartData.map((item, key) => (
              <TableRow key={key}>
                <StyledTableCellHead scope="row">
                  {item.month}
                </StyledTableCellHead>
                <StyledTableCell>
                  {item.quantity}
                </StyledTableCell>
                <StyledTableCellBar>
                  <StyledChartBar size={linearScale(item.value, max)} />
                </StyledTableCellBar>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </QuantityChartStyled>
  );
};

QuantityChart.propTypes = {
  chartData: PropTypes.array,
};

export default QuantityChart;
